export const MFA_MODAL_OPEN = 'accounts.security.mfa.open';
export const MFA_MODAL_STEP = 'accounts.security.mfa.step';
export const MFA_MODAL_CONTACT_ADDED = 'accounts.security.mfa.contact-added.success';
